var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", {
        staticStyle: { height: "390px" },
        attrs: { id: "centreLeft2Chart" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }